import { EarlyWarningBreadcrumb } from './EarlyWarningBreadcrumb';

export function EarlyWarningHeader() {
  return (
    <div className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="px-4 sm:px-6 lg:px-8 h-10 flex items-center justify-between">
        <EarlyWarningBreadcrumb />
      </div>
    </div>
  );
}